import { Component, inject } from "@angular/core";
import { AppSettings, APP_SETTINGS } from "../../app.settings";

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"]
})
export class FooterComponent {
    readonly env = inject<AppSettings>(APP_SETTINGS);

    version = `${this.env.info.product}\nVersion: ${this.env.info.version}\nBuild version: ${this.env.info.fileVersion}\n${this.env.info.copyright}`;

}
